var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaximize02 = function SvgMaximize02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 21.5v-5.266h1.501v3.77h3.762V21.5zm13.737 0v-1.495h3.765v-3.77H21.5V21.5zM2.5 7.766V2.5h5.263v1.495H4v3.77zm17.5 0v-3.77h-3.763V2.5H21.5v5.266z"
  })));
};
export default SvgMaximize02;